import { render, staticRenderFns } from "./PaymentTable.vue?vue&type=template&id=84a1f2c4&scoped=true&"
import script from "./PaymentTable.vue?vue&type=script&lang=js&"
export * from "./PaymentTable.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTable.vue?vue&type=style&index=0&id=84a1f2c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a1f2c4",
  null
  
)

export default component.exports